import { cn } from '@/lib/utils'
import { Card } from '@/components/ui/card'

const UpdateSectionCard = ({
  icon: Icon,
  heading,
  headingLevel: Heading = 'h2',
  children,
  className,
}) => (
  <Card className={cn('border-border/60 gap-4 border p-5 sm:p-6', className)}>
    <div className="flex items-center gap-3">
      {Icon && (
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#fff3ec]">
          <Icon className="h-6 w-6 text-[#FF914D]" aria-hidden="true" />
        </span>
      )}
      <Heading className="text-foreground text-xl font-bold sm:text-2xl">
        {heading}
      </Heading>
    </div>
    <div className="text-foreground space-y-3 text-base leading-relaxed">
      {children}
    </div>
  </Card>
)

export default UpdateSectionCard
